document.addEventListener("click", function (e) {
  const swatch = e.target.closest(".color-swatch");
  if (!swatch) return;

  const card = swatch.closest(".card-wrapper");
  if (!card) return;

  const handle = swatch.dataset.productHandle;
  if (!handle) return;

  const template = card.querySelector(
    `.card-templates template[data-handle="${handle}"]`
  );
  if (!template) return;

  const currentContent = card.querySelector(".card__contentnew");
  if (!currentContent) return;

  /* Swap content */
  const newContent = template.content.firstElementChild.cloneNode(true);
  currentContent.replaceWith(newContent);

  /* Swatch UI */
  card.querySelectorAll(".color-swatch").forEach(s =>
    s.classList.remove("selected")
  );
  swatch.classList.add("selected");

  /* 🔥 RE-INIT SWIPER */
  reInitSwiper(card);
});
function reInitSwiper(card) {
  const swipers = card.querySelectorAll(".swiper");

  swipers.forEach(swiperEl => {
    // Destroy existing instance if any
    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    // Re-init using existing attributes
    new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: true,
      watchOverflow: true,
      navigation: {
        nextEl: swiperEl.querySelector(".swiper-button-next"),
        prevEl: swiperEl.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  });
}





// document.addEventListener("click", function (e) {
//   const swatch = e.target.closest(".color-swatch");
//   if (!swatch) return;

//   const card = swatch.closest(".card-wrapper");
//   if (!card) return;

//   const cardContent = card.querySelector(".card__contentnew");
//   if (!cardContent) return;

//   /* Swap entire card content */
//   cardContent.innerHTML = swatch.dataset.cardHtml;

//   /* Update selected state */
//   card.querySelectorAll(".color-swatch").forEach(s =>
//     s.classList.remove("selected")
//   );
//   swatch.classList.add("selected");

//   /* 🔥 RE-INIT SWIPER */
//   reInitCardSwiper(card);
// });

// /* ================================
//    SWIPER RE-INIT FUNCTION
// ================================ */
// function reInitCardSwiper(card) {
//   const swiperEl = card.querySelector(".swiper");
//   if (!swiperEl || typeof Swiper === "undefined") return;

//   /* Destroy old instance if exists */
//   if (swiperEl.swiper) {
//     swiperEl.swiper.destroy(true, true);
//   }

//   /* Init again */
//   new Swiper(swiperEl, {
//     slidesPerView: 1,
//     loop: true,
//     navigation: {
//       nextEl: card.querySelector(".swiper-button-next"),
//       prevEl: card.querySelector(".swiper-button-prev"),
//     },
//     pagination: {
//       el: card.querySelector(".swiper-pagination"),
//       clickable: true,
//     },
//     observer: true,
//     observeParents: true,
//   });
// }






// document.addEventListener("click", function (e) {
//   const swatch = e.target.closest(".color-swatch");
//   if (!swatch) return;

//   const card = swatch.closest(".card-wrapper");
//   if (!card) return;

//   const cardContent = card.querySelector(".card___content");
//   if (!cardContent) return;

//   /* Swap entire card content */
//   cardContent.innerHTML = swatch.dataset.cardHtml;

//   /* Update selected state */
//   card.querySelectorAll(".color-swatch").forEach(s => s.classList.remove("selected"));
//   swatch.classList.add("selected");
// });



